import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InfectionControlRoutingModule } from './infection-control-routing.module';
import { InfectionControlCategoriesComponent } from './infection-control-categories/infection-control-categories.component';
import { SharedModule } from '../blocks/ngPrime/common/shared';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlocksModule } from '../blocks/blocks.module';
import { TabModule } from '../blocks/tabs/tab.module';
import { StepperModule } from '../blocks/stepper/stepper.module';
import { FastSearchModule } from '../blocks/ui-component/fast-search/fast-search.module';
import { ControlsModule } from '../blocks/controls/controls.module';
import { IconActionModule } from '../blocks/ui-component/action-icon/action-icon.module';
import { SelectizeModule } from '../blocks';
import { InfectionControlMontoringComponent } from './infection-control-montoring/infection-control-montoring.component';
import { InfectionControlTrackingComponent } from './infection-control-tracking/infection-control-tracking.component';
import { InfectionControlPlaningComponent } from './infection-control-planing/infection-control-planing.component';

@NgModule({
  declarations: [InfectionControlCategoriesComponent, InfectionControlMontoringComponent, InfectionControlTrackingComponent, InfectionControlPlaningComponent],
  imports: [
    CommonModule,
    InfectionControlRoutingModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    SharedModule,
    BlocksModule,
    TabModule,
    StepperModule,
    FastSearchModule,
    ReactiveFormsModule,
    ControlsModule,
    IconActionModule,
    SelectizeModule
  ]
})
export class InfectionControlModule { }
